import FundraiserRedirectOldPage from '@/pages/fundraisers/public/FundraiserRedirectOldPage.vue'
import TeamDonatePage from '@/pages/fundraisers/public/TeamDonatePage.vue'
import FundraiserDonationReturnPublicPage from '@/pages/fundraisers/public/donation-return/FundraiserDonationReturnPublicPage.vue'
import TeamPublicPage from '@/pages/fundraisers/public/TeamPublicPage.vue'
import FundraiserJoinPage from '@/pages/fundraisers/public/FundraiserJoinPage.vue'
import TeamDonationReturnPublicPage from '@/pages/fundraisers/public/donation-return/TeamDonationReturnPublicPage.vue'
import TeamRedirectOldPage from '@/pages/fundraisers/public/TeamRedirectOldPage.vue'

export default [
  {
    path: '/teams/:teamId/donate',
    name: 'TeamDonatePage',
    component: TeamDonatePage,
    props: route => ({ teamId: parseInt(route.params.teamId)})
  },
  {
    path: '/campaigns/:fundraiserId/join/teams/:teamId',
    name: 'FundraiserTeamPublicJoinPage',
    component: FundraiserJoinPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId), teamId: parseInt(route.params.teamId)})
  },
  {
    path: '/campaigns/:fundraiserId/teams/:teamId',
    name: 'FundraiserTeamPublicPage',
    component: TeamPublicPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId), teamId: parseInt(route.params.teamId)})
  },
  {
    path: '/teams/:teamId/donations/:donationId/return',
    name: 'TeamDonationReturnPublicPage',
    component: TeamDonationReturnPublicPage,
    props: route => ({ teamId: parseInt(route.params.teamId), donationId: parseInt(route.params.donationId)})
  },
  {
    path: '/teams-redirect/:oldId',
    name: 'TeamRedirectOld',
    component: TeamRedirectOldPage,
    props: route => ({ oldId: parseInt(route.params.oldId) })
  }
]
